import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface IAdsField {
	setAds: (value: string) => void;
}

const AdsField: React.FC<IAdsField> = ({ setAds }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterAds') }], [t]);

	const handleChange = useCallback(
		(e: React.ChangeEvent<HTMLInputElement>) => {
			const onlyDigits = e.target.value.replace(/\D/g, '');
			setAds(onlyDigits);
			return onlyDigits;
		},
		[setAds],
	);

	return (
		<FormInput
			testId="AdsField"
			name="ads"
			label="adsLabel"
			getValueFromEvent={handleChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(AdsField);
